import { Society } from 'types/Society';

import {
  DEFAULT_SORT_BY,
  DEFAULT_SORT_ORDER,
  PARTNER_NUMBER_SORT_BY,
  SORT_FIELD_ID_BY_API,
} from '../constants/sortFieldMap';

export const getDefaultPartnerListSort = (society?: Society | null) => {
  if (!society) {
    return {
      sortBy: DEFAULT_SORT_BY,
      sortOrder: DEFAULT_SORT_ORDER as 'desc',
      sortFieldId: SORT_FIELD_ID_BY_API[DEFAULT_SORT_BY],
    };
  }

  const hasNoShares = (society.sharesCount?.actual ?? 0) === 0;

  if (hasNoShares) {
    return {
      sortBy: PARTNER_NUMBER_SORT_BY,
      sortOrder: 'asc' as const,
      sortFieldId: SORT_FIELD_ID_BY_API[PARTNER_NUMBER_SORT_BY],
    };
  }

  return {
    sortBy: DEFAULT_SORT_BY,
    sortOrder: DEFAULT_SORT_ORDER as 'desc',
    sortFieldId: SORT_FIELD_ID_BY_API[DEFAULT_SORT_BY],
  };
};
